export function calculateRemain(total, done, remain_s, uploadStartedAt) {
  const elapsed_ms = new Date() - uploadStartedAt
  const percentage = Math.floor((done * 100) / total)

  if (percentage > 10 || elapsed_ms > 10000) {
    if (total == done) {
      return 'Finalizing'
    }

    // Resuming uploads sometimes reports negative time remaining.
    if (remain_s <= 0) return ''

    let [remain_m, remain_h] = Array.from([0, 0])
    if (remain_s > 60) {
      ;[remain_m, remain_s] = Array.from([
        Math.floor(remain_s / 60),
        remain_s % 60,
      ])
    }
    if (remain_m > 60) {
      ;[remain_h, remain_m] = Array.from([
        Math.floor(remain_m / 60),
        remain_m % 60,
      ])
    }

    let remain = ''
    if (remain_h > 0) {
      remain += `${remain_h}h `
    }
    if (remain_m > 0 || remain_h > 0) {
      remain += `${remain_m}m `
    }

    // Don't add seconds when >= 1 hour is remaining
    if (remain_h < 1) remain += `${remain_s}s`

    return remain
  } else {
    return ''
  }
}
